export default __webpack_public_path__ + "static/media/uploadFrame2.ad1fd787.png";